import React from 'react';
import PropTypes from 'prop-types';

const Radio = (props) => {
  const classes = props.className ? props.className : '';
  const classNames = `form-group ${classes}`;

  return( <div className={classNames}>
      <label htmlFor={props.name} className="form-label">{props.title}</label>
      <div className="checkbox-group">
        {props.options.map((option, i) => {
          const isSelected = option === props.selected;
          return (
            <div key={i}>
              <label>
                <input
                  type="radio"
                  id = {`${props.name}-${i}`}
                  name={props.name}
                  className="form-check-input"
                  onChange={props.handleChange}
                  value={option}
                  checked={option === props.selected}
                /> {option}
              </label>
            </div>
          );
        })}
      </div>
    </div>
  );

};

Radio.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selected: PropTypes.string.isRequired
};

export default Radio;